/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, minutes: NonNullable<unknown> }} Week_Day_MetaInputs */

const en_us2_week_day_meta = /** @type {(inputs: Week_Day_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercise · ~${i?.minutes} min`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 exercise · ~${i?.minutes} min`);
	return /** @type {LocalizedString} */ (`${i?.count} exercises · ~${i?.minutes} min`)
	
};

const pt_br2_week_day_meta = /** @type {(inputs: Week_Day_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercício · ~${i?.minutes} min`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 exercício · ~${i?.minutes} min`);
	return /** @type {LocalizedString} */ (`${i?.count} exercícios · ~${i?.minutes} min`)
	
};

const es_419_week_day_meta = /** @type {(inputs: Week_Day_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 ejercicio · ~${i?.minutes} min`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 ejercicio · ~${i?.minutes} min`);
	return /** @type {LocalizedString} */ (`${i?.count} ejercicios · ~${i?.minutes} min`)
	
};

const pt_pt2_week_day_meta = /** @type {(inputs: Week_Day_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercício · ~${i?.minutes} min`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 exercício · ~${i?.minutes} min`);
	return /** @type {LocalizedString} */ (`${i?.count} exercícios · ~${i?.minutes} min`)
	
};

const fr_fr2_week_day_meta = /** @type {(inputs: Week_Day_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercice · ~${i?.minutes} min`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 exercice · ~${i?.minutes} min`);
	return /** @type {LocalizedString} */ (`${i?.count} exercices · ~${i?.minutes} min`)
	
};

const de_de2_week_day_meta = /** @type {(inputs: Week_Day_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Übung · ~${i?.minutes} min`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 Übung · ~${i?.minutes} min`);
	return /** @type {LocalizedString} */ (`${i?.count} Übungen · ~${i?.minutes} min`)
	
};

const it_it2_week_day_meta = /** @type {(inputs: Week_Day_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 esercizio · ~${i?.minutes} min`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 esercizio · ~${i?.minutes} min`);
	return /** @type {LocalizedString} */ (`${i?.count} esercizi · ~${i?.minutes} min`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 exercise · ~{minutes} min" |
* | "-1" | "1 exercise · ~{minutes} min" |
* | * | "{count} exercises · ~{minutes} min" |
*
* @param {Week_Day_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const week_day_meta = /** @type {((inputs: Week_Day_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Day_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_week_day_meta(inputs)
	if (locale === "es-419") return es_419_week_day_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_week_day_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_week_day_meta(inputs)
	if (locale === "de-DE") return de_de2_week_day_meta(inputs)
	if (locale === "it-IT") return it_it2_week_day_meta(inputs)
	return en_us2_week_day_meta(inputs)
});
export { week_day_meta as "week.day_meta" }